import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DOATypeAmountDto } from '../../../interface/permanentdelegation/doatype-amount-dto';
import { DoaTypes } from '../../../interface/permanentdelegation/doatypes';
import { PermanentdelegationService } from '../../../services/PermanentDelegation/permanentdelegation.service';
import { AppComponent } from '../../../app.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SharedServices } from '../../../shared/services/shared.services';


@Component({
  selector: 'app-managedoatypes',
  imports: [CommonModule, FormsModule, ReactiveFormsModule,MatProgressSpinner],
  templateUrl: './managedoatypes.component.html',
  styleUrls: ['./managedoatypes.component.css']
})
export class ManagedoatypesComponent implements OnInit {
  doaTypeAmounts: DOATypeAmountDto[] = [];
  doaType: DoaTypes[] = [];
  selectedAmounts: DOATypeAmountDto[] = [];
  selectedTypeName: string | null = null;
  selectedTypeCode: string | null = null;
  searchControl = new FormControl('');
  loggedUserEmail:string="";
  loggedUserCai:string="";
  showFields: boolean = false;
  filteredDoaTypes$: Observable<DoaTypes[]> = new Observable<DoaTypes[]>(); // Initialize with correct type

  constructor( private permanentdelegationService: PermanentdelegationService,
    private appComponent:AppComponent,
    private sharedService: SharedServices 
  ) {
    this.loggedUserEmail = this.appComponent.loggedUserEmail;
    this.loggedUserCai=this.appComponent.loggedUserCai

   }

  ngOnInit(): void {
    this.showFields = true;
    this.loadDoaTypes();
    this.filteredDoaTypes$ = this.searchControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filterDoaTypes(value || ''))
    );
  }

  loadDoaTypes(): void {
    this.permanentdelegationService.getDoaType().subscribe(
      (data: DoaTypes[]) => {
        this.doaType = data;
        this.showFields = false;
        this.filteredDoaTypes$ = this.searchControl.valueChanges.pipe(
          startWith(''),
          map(value => this.filterDoaTypes(value || ''))
        );
        this.fetchAmountsByTypeCode(); // Fetch amounts for the first DOA type by default
      },
      error => {
        console.error('Error loading DOA types', error);
      }
    );
  }

  filterDoaTypes(value: string): DoaTypes[] {
    const filterValue = value.toLowerCase();
    return this.doaType.filter(type => type.typeName.toLowerCase().includes(filterValue));
  }

  fetchAmountsByTypeCode(typeCode: string | null = null, typeName: string | null = null): void {
    if (!typeCode && this.doaType.length > 0) {
      typeCode = this.doaType[0].typeCode;
      typeName = this.doaType[0].typeName;
    }

    if (typeCode && typeName) {
      this.selectedTypeName = typeName;
      this.selectedTypeCode = typeCode;
      this.permanentdelegationService.getAmountByTypeCode(typeCode).subscribe(
        (data: DOATypeAmountDto[]) => {
          this.selectedAmounts = data;
        },
      );
    }
  }

  addAmount(newAmount: string): void {

    const numericValue = Number(newAmount.replace(/,/g, ''));
    const formattedAmount = numericValue.toLocaleString('en-US');

    if (newAmount && this.selectedTypeCode) {
      const currentDate = new Date().toISOString().split('T')[0];
      const addDoaTypeDto: DOATypeAmountDto = {
        amount: formattedAmount,
        doatype: this.selectedTypeCode,
        currency: 'USD', // or any other currency you want to use
        addedby: this.loggedUserCai,
        addeddate: currentDate,
        editedby: this.loggedUserCai, // replace with actual user info
        editeddate: currentDate,
        newId: 0, // This will be generated by the API
        CreatedBy: this.loggedUserEmail,
      };

      this.permanentdelegationService.addDoaType(addDoaTypeDto).subscribe(() => {
        this.fetchAmountsByTypeCode(this.selectedTypeCode!, this.selectedTypeName!);
        this.sharedService.openModal('Message', `Amount added successfully`);
        return;

      });
    }
  }
  


  deleteAmount(newId: number): void {
      this.permanentdelegationService.deleteDoaType(newId).subscribe(
      () => {
        
        this.fetchAmountsByTypeCode(this.selectedTypeCode!, this.selectedTypeName!);
        this.sharedService.openModal('Message', `Amount deleted successfully`);
        return;
      },
    );
  }
}
